<div *ngIf="config?.selectors?.length">
  <a name="{{config.name}}" [title]="config.name"></a>
  <div class="d-flex justify-content-sm-around pb-2 pt-2 container-ccw {{styleClass}}">
    <ng-container *ngFor="let selector of config.selectors">
      <input type="radio" [(ngModel)]="selectedValue" name="{{seed}}-{{config.name}}" id="{{seed}}-{{selector.id}}" class="k-radio focusable" [value]="selector.value" [disabled]="config.isReadOnly">
      <label class="k-radio-label" for="{{seed}}-{{selector.id}}" [title]="selector.text">{{selector.text}}</label>
    </ng-container>
  </div>
</div>
